import React from "react";
import { Row, Col, message } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

import { ButtonWrapper } from "../buttons";
import Cookies from "js-cookie";
import { Link, Router, useHistory } from "react-router-dom";

const HeaderWrapper = (props) => {
  const { collapsed, toggleCollapsed } = props;
  const history = useHistory();

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        borderBottom: "1px solid rgba(0,0,0,0.09)",
        boxShadow: "2px 2px 3px rgba(0,0,0,0.09)",
        padding: "8px 32px",
      }}
    >
      <Row justify="space-between" align="middle">
        <Col>
          {collapsed ? (
            <MenuUnfoldOutlined
              onClick={() => toggleCollapsed(false)}
              style={{ fontSize: 24 }}
            />
          ) : (
            <MenuFoldOutlined
              onClick={() => toggleCollapsed(true)}
              style={{ fontSize: 24 }}
            />
          )}
        </Col>

        <Col>
          <Row style={{ width: 200 }} justify="space-around" align="middle">
            <Col>
              <p className="m-0">Hello Admin</p>
            </Col>
            <Col>
              {/* <Link to={"/"}> */}
              <ButtonWrapper
                onClick={() => {
                  sessionStorage.removeItem("user");
                  window.location.pathname = "/";
                }}
              >
                Logout
              </ButtonWrapper>
              {/* </Link> */}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default HeaderWrapper;
